import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';

class MapContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      markerPosition: props.initialCoordinates,
      clickedLocation: {
        coordinates: {
          lat: null,
          lng: null,
        },
        address: null,
      },
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.initialCoordinates !== this.props.initialCoordinates) {
      this.setState({
        markerPosition: this.props.initialCoordinates
      });
    }
  }
  
  handleMarkerChange = (coord) => {
    this.getAddressFromCoordinates(coord, (address) => {
      this.setState(
        (prevState) => ({
          markerPosition: coord,
          clickedLocation: {
            ...prevState.clickedLocation,
            coordinates: coord,
            address: address,
          },
        }),
        () => this.passLocationToParent()
      );
    });
  
    if (this.props.onMarkerChange) {
      this.props.onMarkerChange(coord);
    }
  };
  
  handleMapClick = ({ lat, lng }) => {
    const clickedCoordinates = { lat, lng };
    this.getAddressFromCoordinates(clickedCoordinates, (address) => {
      this.setState(
        (prevState) => ({
          markerPosition: clickedCoordinates,
          clickedLocation: {
            ...prevState.clickedLocation,
            coordinates: clickedCoordinates,
            address: address,
          },
        }),
        () => this.passLocationToParent()
      );
    });
  
    if (this.props.onMarkerChange) {
      this.props.onMarkerChange(clickedCoordinates);
    }
  };
  
  getAddressFromCoordinates = async ({ lat, lng }, callback) => {
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${process.env.REACT_APP_GOOGLE_MAP_API_KEY}`
      );
  
      if (!response.ok) {
        throw new Error('Failed to fetch address');
      }
  
      const data = await response.json();
  
      if (data.results && data.results.length > 0) {
        const address = data.results[0].formatted_address;
        callback(address);
      } else {
        callback(null);
      }
    } catch (error) {
      console.error('Error fetching address:', error);
      callback(null);
    }
  };

  passLocationToParent = () => {
    const { onLocationChange } = this.props;
    const { clickedLocation } = this.state;

    if (onLocationChange) {
      onLocationChange(clickedLocation);
    }
  };

  render() {
    const { markerPosition, clickedLocation } = this.state;

    return (
      <div style={{ height: '400px', width: '100%' }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAP_API_KEY }}
          center={markerPosition}
          defaultZoom={15}
          // onClick={(event) => this.handleMapClick(event)}
        >
          <Marker
            lat={markerPosition.lat}
            lng={markerPosition.lng}
            onDragEnd={(e) => this.handleMarkerChange({ lat: e.x, lng: e.y })}
          />
        </GoogleMapReact>
      </div>
    );
  }
}

// Marker.jsx
const Marker = ({ text, lat, lng, onDragEnd }) => (
  <div
    style={{
      position: 'absolute',
      width: '20px',
      height: '20px',
      backgroundColor: 'red',
      borderRadius: '50%',
      textAlign: 'center',
      cursor: 'grab',
      transform: 'translate(-50%, -50%)',
    }}
    draggable
    onDragEnd={(e) => onDragEnd({ lat: e.x, lng: e.y })}
  >
    {text}
  </div>
);

export default MapContainer;


